import Icon from '../components/Icon.vue'

Icon.register({
  'pen-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M497.9 74.2L437.8 14.1C419.1-4.7 388.7-4.7 369.9 14.1L313.4 70.6 441.4 198.6 497.9 142.1C516.7 123.3 516.7 92.9 497.9 74.2zM251.1 53.6C235.5 38 210.2 38 194.6 53.6L75.8 172.4C69.5 178.7 69.5 188.8 75.8 195.1L98.4 217.7C104.7 223.9 114.8 223.9 121.1 217.7L222.9 115.9 245.5 138.5 94 290A327-327 0 0 1 0.2 485.1L0.1 485.3C-1.6 500.6 11.3 513.5 26.6 511.9A327-327 0 0 1 222 418.1L418.8 221.3 336 138.5 251.1 53.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pen-alt.js
// module id = j3Ow
// module chunks = 144